
<a-select :options="options" :compress="compress" v-model.sync="localValue" :is-searchable="false" v-bind="$attrs"></a-select>
